export const reportMenus = [
  { name: "Sales", children: [
    { name: "Sales Report", path: "/report/sales-report" },
    { name: "Weight Sheet", path: "/report/weight-slip" },
    { name: "Fixation", path: "/report/common-fixation" },
    { name: "Sales Turnover", path: "/report/crystal-reports/sales-turnover" },
  ] },
  { name: "Shipping", children: [
    { name: "Deal Status Report", path: "/report/deal-status" },
    { name: "Pending Status Report", path: "/report/pending-status" },
    { name: "Claim", path: "/report/claim" },
  ] },
  { name: "Accounts", children: [
    { name: "Opening Balance", path: "/report/opening-balance" },
    { name: "Commission Report", path: "/report/commission" },
    { name: "Invoice", path: "/report/accounts/invoice-list" },
    { name: "Supplier Statement", path: "/report/supplier-statement" },
    { name: "Payment Received List", path: "/report/accounts/inward-remittance" },
    { name: "Dr/Cr List", path: "/report/accounts/credit-debit" },
    { name: "Forex Diff", path: "/report/accounts/forex-diff" },
  ] },
];
